import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { packageIncludes } from '../data/comparison';
export function OfferSection() {
  return <section id="buy" className="flex min-h-[100svh] w-full flex-col justify-center bg-bone py-6 sm:py-20" aria-labelledby="offer-title" data-id="element-143" data-mp="de55l1s0ikjq">
      <div className="mx-auto w-full max-w-md px-4 sm:max-w-lg sm:px-8" data-id="element-144" data-mp="icorx3aipycm">
        <div className="overflow-hidden rounded-2xl border border-court-950/10 bg-white shadow-[0_24px_60px_-32px_rgba(0,0,0,0.45)]" data-id="element-145" data-mp="me1xrddm21jj">
          <p className="bg-court-950 px-4 py-2.5 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ball" data-id="element-146" data-mp="repnlvq3scc6">
            🏆 Complete Package
          </p>

          <div className="px-5 pb-5 pt-5 text-center sm:px-8 sm:pb-7 sm:pt-7" data-id="element-147" data-mp="2t6b5sds3vrjy">
            <h2 id="offer-title" className="font-display text-xl font-black uppercase leading-none tracking-tight text-court-950 sm:text-2xl" data-id="element-148" data-mp="2y3uk1dot04bw">
              Tennis 360™
            </h2>
            <p className="mt-1.5 text-xs text-court-700 sm:text-sm" data-id="element-149" data-mp="xw0bgv1o277g">12 Volumes + 6 Bonuses</p>

            <div className="mt-4 rounded-xl bg-bone px-4 py-3.5 sm:mt-5" data-id="element-150" data-mp="syibhu5mn2bl">
              <p className="text-xs text-court-600 sm:text-sm" data-id="element-151" data-mp="own9enfvgkwr">
                Total value: <span className="line-through" data-id="element-152" data-mp="1lme2qjcfg20z">$318</span>
              </p>
              <p className="mt-0.5 flex items-end justify-center gap-1.5" data-id="element-153" data-mp="1lka2qchnfn5z">
                <span className="pb-1.5 font-display text-2xl font-black text-court-950" data-id="element-154" data-mp="1gokwxrf1da18">$</span>
                <span className="font-display text-5xl font-black leading-none tracking-tight text-court-950 sm:text-6xl" data-id="element-155" data-mp="1ckd71qwudo1f">
                  27
                </span>
                <span className="pb-1.5 text-xs font-medium text-court-700 sm:text-sm" data-id="element-156" data-mp="172fxam3e598">
                  one-time
                </span>
              </p>
              <p className="mt-3 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-2" data-id="element-157" data-mp="3sex33dzfwba9">
                <span className="rounded-full bg-clay px-3.5 py-1 text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-158" data-mp="3tusteue8ebyy">
                  Save $291
                </span>
                <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-court-950" data-id="element-159" data-mp="3ksjhc03beajg">
                  Lifetime access
                </span>
              </p>
            </div>

            <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-court-600 sm:text-[11px]" data-id="element-160" data-mp="3b2q5qz369vf7">
              What's included
            </p>
            <ul className="mt-3 space-y-2 text-left" data-id="element-161" data-mp="315ltbqz4pebl">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[12.5px] leading-snug text-court-800 sm:text-sm" data-id="element-162" data-mp="3645fnshmws4h">
                  <span className="mt-px flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-clay/10 sm:h-[18px] sm:w-[18px]" aria-hidden="true" data-id="element-163" data-mp="2s702z9nf0v09">
                    <CheckIcon className="h-2.5 w-2.5 text-clay" strokeWidth={4} data-id="element-164" data-mp="28j3vb7n3zgmo" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-5" data-id="element-165" data-mp="2mgag17re7pej">
              <Countdown data-id="element-166" data-mp="2igs24vxzoel7" />
              <p className="mt-1.5 text-[10px] leading-snug text-court-600 sm:text-xs" data-id="element-167" data-mp="2ifgq68ue40j0">
                After that, the price goes up by $5 and never comes back down.
              </p>
            </div>

            <div className="mt-4" data-id="element-168" data-mp="2rh6olymovzqa">
              <CtaButton size="hero" variant="dark" className="w-full" data-id="element-169" data-mp="366me7bahhz4e">
                🚀 Get Tennis 360 Now — Only $27
              </CtaButton>
              <p className="mt-2.5 flex items-center justify-center gap-1.5 text-[10px] text-court-600 sm:text-xs" data-id="element-170" data-mp="318udbrrv32o2">
                <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-171" data-mp="3f7kaf7eol2cf" />
                Backed by our 7-day money-back guarantee
              </p>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2 border-t border-court-950/10 pt-4 text-[10px] text-court-700 sm:text-[11px]" data-id="element-172" data-mp="18iimjdt0bvbx">
              <span className="flex items-center justify-center gap-1.5" data-id="element-173" data-mp="1i8to4tp7xsfn">
                <LockIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-174" data-mp="1iay3q8whcfvr" /> Secure
                Payment
              </span>
              <span className="flex items-center justify-center gap-1.5" data-id="element-175" data-mp="pkpha4uwv9bd">
                <ZapIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-176" data-mp="uj95kbwz8x6w" /> Access in
                5 min
              </span>
              <span className="flex items-center justify-center gap-1.5" data-id="element-177" data-mp="yjt1xd9q7wrz">
                <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-178" data-mp="13jp4d82rzg5f" />{' '}
                7-Day Guarantee
              </span>
              <span className="flex items-center justify-center gap-1.5" data-id="element-179" data-mp="29zris3b5bn3r">
                <CreditCardIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-180" data-mp="2exszihl3nac2" />{' '}
                Card · Bank Transfer
              </span>
            </div>
          </div>
        </div>

        <p className="mt-3 text-center text-[10px] leading-snug text-court-600 sm:text-xs" data-id="element-181" data-mp="2k595sq2it6k0">
          ⏰ Limited-time offer · Everything included. One single price. No hidden fees. No
          surprises. · <span className="font-semibold text-clay" data-id="element-182" data-mp="2bautmwdaec54">🔴 Limited spots — 72% claimed</span>
        </p>
      </div>
    </section>;
}